<div class="flex-container">
  <div class="flex-container__title-area">
    <img [src]="country.countryInfo.flag" alt="flag">
    <h1 class="flex-container__title">{{country.country}}</h1>
  </div>

  <div class="flex-container__data-area">
    <div class="flex-container__data--item">
      <span class="data-title"> Cases Per Million: </span>
      <span class="data-number">{{country.casesPerOneMillion | number}}</span>
    </div>
    <div class="flex-container__data--item">
      <span class="data-title"> Deaths Per Million: </span>
      <span class="data-number">{{country.deathsPerOneMillion | number}}</span>
    </div>
    <div class="flex-container__data--item">
      <span class="data-title"> Total Deaths: </span>
      <span class="data-number">{{country.deaths | number}}</span>
    </div>
    <div class="flex-container__data--item">
      <span class="data-title"> Today Deaths: </span>
      <span class="data-number">{{country.todayDeaths | number}}</span>
    </div>
    <div class="flex-container__data--item">
      <span class="data-title"> Population Affected (Confirmed): </span>
      <span class="data-number">{{country.cases / country.population | percent: "1.2"}}</span>
    </div>
    <div class="flex-container__data--item">
      <span class="data-title"> Confirmed Cases Fatality Rate: </span>
      <span class="data-number">{{country.deaths / country.cases | percent: "1.2"}}</span>
    </div>
    <div class="flex-container__data--item">
      <span class="data-title"> Population: </span>
      <span class="data-number">{{country.population | number}}</span>
    </div>
    <small>(Sometimes today data are zero because of the different timezones that goverments submit the data)</small>
    <mat-dialog-actions align="end">
      <button mat-button mat-dialog-close class="cancel-btn">Cancel</button>
      <button mat-raised-button
              style="background-color: #f2aa4cff"
              [mat-dialog-close]="true"
              cdkFocusInitial
              [routerLink]="['country/' + country.country]">Details
      </button>
    </mat-dialog-actions>
  </div>
</div>
